module.exports = __webpack_public_path__ + "static/media/headerImg.20ecfad6.png";